import type { PointInteret } from "./types";

export const HOTELS_5_ETOILES: PointInteret[] = [
  {
    id: "HOTEL_CAP_D_ANTIBES_BEACH_HOTEL_ANTIBES",
    nom: "Cap d'Antibes Beach Hôtel",
    adresse: "10 boulevard Maréchal Juin, 06160 Antibes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.557,
      lon: 7.121,
    },
  },
  {
    id: "HOTEL_HOTEL_DU_CAP_EDEN_ROC_ANTIBES",
    nom: "Hôtel du Cap-Eden-Roc",
    adresse: "Boulevard JF Kennedy, 06160 Antibes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.553,
      lon: 7.112,
    },
  },
  {
    id: "HOTEL_HOTEL_VILLA_FABULITE_ANTIBES",
    nom: "Hôtel Villa Fabulite",
    adresse: "35 chemin du Croûton, 06160 Antibes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5612,
      lon: 7.1198,
    },
  },
  {
    id: "HOTEL_HOTEL_VILLA_MARAE_ANTIBES",
    nom: "Hôtel Villa Marae",
    adresse: "19 rue Lacan, 06160 Antibes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.566,
      lon: 7.124,
    },
  },
  {
    id: "HOTEL_LA_RESERVE_DE_BEAULIEU_SPA_BEAULIEU_SUR_MER",
    nom: "La Réserve de Beaulieu & Spa",
    adresse: "5 boulevard du Général Leclerc, 06310 Beaulieu-sur-Mer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7074,
      lon: 7.3322,
    },
  },
  {
    id: "HOTEL_INTERCONTINENTAL_CARLTON_CANNES_CANNES",
    nom: "InterContinental Carlton Cannes",
    adresse: "58 boulevard de la Croisette, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5509,
      lon: 7.0184,
    },
  },
  {
    id: "HOTEL_HOTEL_MAJESTIC_BARRIERE_CANNES",
    nom: "Hôtel Majestic Barrière",
    adresse: "10 boulevard de la Croisette, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5513,
      lon: 7.0152,
    },
  },
  {
    id: "HOTEL_GRAND_HYATT_CANNES_HOTEL_MARTINEZ_CANNES",
    nom: "Grand Hyatt Cannes Hôtel Martinez",
    adresse: "73 boulevard de la Croisette, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5503,
      lon: 7.0224,
    },
  },
  {
    id: "HOTEL_JW_MARRIOTT_CANNES_CANNES",
    nom: "JW Marriott Cannes",
    adresse: "50 boulevard de la Croisette, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5508,
      lon: 7.0188,
    },
  },
  {
    id: "HOTEL_MONDRIAN_CANNES_CANNES",
    nom: "Mondrian Cannes",
    adresse: "5 rue Latour-Maubourg, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.552,
      lon: 7.016,
    },
  },
  {
    id: "HOTEL_FIVE_SEAS_HOTEL_CANNES_CANNES",
    nom: "Five Seas Hôtel Cannes",
    adresse: "1 rue Notre Dame, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5515,
      lon: 7.017,
    },
  },
  {
    id: "HOTEL_HOTEL_BELLE_PLAGE_CANNES",
    nom: "Hôtel Belle Plage",
    adresse: "6 rue Brougham, 06400 Cannes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.549,
      lon: 7.0148,
    },
  },
  {
    id: "HOTEL_HOTEL_CAP_ESTEL_EZE",
    nom: "Hôtel Cap Estel",
    adresse: "1312 avenue Raymond Poincaré, 06360 Èze",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.725,
      lon: 7.368,
    },
  },
  {
    id: "HOTEL_CHATEAU_DE_LA_CHEVRE_D_OR_EZE",
    nom: "Château de la Chèvre d'Or",
    adresse: "Rue du Barri, 06360 Èze",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.729,
      lon: 7.361,
    },
  },
  {
    id: "HOTEL_CHATEAU_EZA_EZE",
    nom: "Château Eza",
    adresse: "Rue de la Pise, 06360 Èze",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7285,
      lon: 7.3605,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_BASTIDE_SAINT_ANTOINE_GRASSE",
    nom: "Hôtel La Bastide Saint-Antoine",
    adresse: "48 avenue Henri Dunant, 06130 Grasse",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.6601,
      lon: 6.9248,
    },
  },
  {
    id: "HOTEL_HOTEL_BELLES_RIVES_JUAN_LES_PINS",
    nom: "Hôtel Belles Rives",
    adresse: "33 boulevard Edouard Baudoin, 06160 Juan-les-Pins",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.57,
      lon: 7.1142,
    },
  },
  {
    id: "HOTEL_HOTEL_JUANA_JUAN_LES_PINS",
    nom: "Hôtel Juana",
    adresse: "Avenue Georges Gallice, 06160 Juan-les-Pins",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5715,
      lon: 7.1126,
    },
  },
  {
    id: "HOTEL_HOTEL_VILLA_GENESIS_MENTON",
    nom: "Hôtel Villa Genesis",
    adresse: "8 avenue de la Madone, 06500 Menton",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7752,
      lon: 7.499,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_MAS_CANDILLE_MOUGINS",
    nom: "Hôtel Le Mas Candille",
    adresse: "Boulevard Clément Rebuffel, 06250 Mougins",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5986,
      lon: 7.0005,
    },
  },
  {
    id: "HOTEL_ANANTARA_PLAZA_NICE_HOTEL_NICE",
    nom: "Anantara Plaza Nice Hôtel",
    adresse: "12 avenue de Verdun, 06000 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7051,
      lon: 7.267,
    },
  },
  {
    id: "HOTEL_BOSCOLO_EXEDRA_NICE_NICE",
    nom: "Boscolo Exedra Nice",
    adresse: "12 boulevard Victor Hugo, 06000 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7032,
      lon: 7.268,
    },
  },
  {
    id: "HOTEL_HOTEL_DU_COUVENT_NICE",
    nom: "Hôtel du Couvent",
    adresse: "2 rue du Couvent, 06300 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.6985,
      lon: 7.2802,
    },
  },
  {
    id: "HOTEL_MAISON_ALBAR_HOTELS_LE_VICTORIA_NICE",
    nom: "Maison Albar Hôtels Le Victoria",
    adresse: "39 avenue de Suède, 06000 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7048,
      lon: 7.2658,
    },
  },
  {
    id: "HOTEL_HOTEL_NEGRESCO_NICE",
    nom: "Hôtel Negresco",
    adresse: "37 promenade des Anglais, 06000 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.6952,
      lon: 7.2601,
    },
  },
  {
    id: "HOTEL_HYATT_REGENCY_NICE_PALAIS_DE_LA_MEDITERRANEE_NICE",
    nom: "Hyatt Regency Nice Palais de la Méditerranée",
    adresse: "13 promenade des Anglais, 06000 Nice",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.6948,
      lon: 7.2627,
    },
  },
  {
    id: "HOTEL_HOTEL_MONTE_CARLO_BEACH_ROQUEBRUNE_CAP_MARTIN",
    nom: "Hôtel Monte Carlo Beach",
    adresse: "Avenue Princesse Grace, 06190 Roquebrune-Cap-Martin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7461,
      lon: 7.436,
    },
  },
  {
    id: "HOTEL_THE_MAYBOURNE_RIVIERA_ROQUEBRUNE_CAP_MARTIN",
    nom: "The Maybourne Riviera",
    adresse: "1771 route de la Turbie, 06190 Roquebrune-Cap-Martin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7645,
      lon: 7.465,
    },
  },
  {
    id: "HOTEL_GRAND_HOTEL_DU_CAP_FERRAT_SAINT_JEAN_CAP_FERRAT",
    nom: "Grand-Hôtel du Cap-Ferrat",
    adresse: "71 boulevard du Général de Gaulle, 06230 Saint-Jean-Cap-Ferrat",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.689,
      lon: 7.3395,
    },
  },
  {
    id: "HOTEL_HOTEL_ROYAL_RIVIERA_SAINT_JEAN_CAP_FERRAT",
    nom: "Hôtel Royal Riviera",
    adresse: "3 avenue Jean Monnet, 06230 Saint-Jean-Cap-Ferrat",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7021,
      lon: 7.3287,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_SAINT_PAUL_SAINT_PAUL_DE_VENCE",
    nom: "Hôtel Le Saint Paul",
    adresse: "86 rue Grande, 06570 Saint-Paul-de-Vence",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.697,
      lon: 7.12,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_MAS_DE_PIERRE_SAINT_PAUL_DE_VENCE",
    nom: "Hôtel Le Mas de Pierre",
    adresse: "2320 route des Serres, 06570 Saint-Paul-de-Vence",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7002,
      lon: 7.1185,
    },
  },
  {
    id: "HOTEL_HOTEL_TIARA_YAKTSA_THEOULE_SUR_MER",
    nom: "Hôtel Tiara Yaktsa",
    adresse: "Corniche d'Or, 06590 Théoule-sur-Mer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5115,
      lon: 6.9402,
    },
  },
  {
    id: "HOTEL_TIARA_MIRAMAR_BEACH_HOTEL_SPA_THEOULE_SUR_MER",
    nom: "Tiara Miramar Beach Hôtel & Spa",
    adresse: "48 avenue de Miramar, 06590 Théoule-sur-Mer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5088,
      lon: 6.9382,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_CHATEAU_DE_THEOULE_THEOULE_SUR_MER",
    nom: "Hôtel Le Château de Théoule",
    adresse: "80 avenue de Miramar, 06590 Théoule-sur-Mer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5079,
      lon: 6.9371,
    },
  },
  {
    id: "HOTEL_CHATEAU_SAINT_MARTIN_SPA_VENCE",
    nom: "Château Saint-Martin & Spa",
    adresse: "2490 avenue des Templiers, 06140 Vence",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.7279,
      lon: 7.1088,
    },
  },
  {
    id: "HOTEL_HOTEL_ILE_ROUSSE_BANDOL",
    nom: "Hôtel Île Rousse",
    adresse: "25 boulevard Louis Lumière, 83150 Bandol",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.136,
      lon: 5.7533,
    },
  },
  {
    id: "HOTEL_CHATEAU_DE_BERNE_FLAYOSC",
    nom: "Château de Berne",
    adresse: "Route de Salernes, 83780 Flayosc",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.524,
      lon: 6.398,
    },
  },
  {
    id: "HOTEL_DOMAINE_DE_L_ASTRAGALE_GASSIN",
    nom: "Domaine de l'Astragale",
    adresse: "Chemin de Coste Brigade, 83580 Gassin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.232,
      lon: 6.598,
    },
  },
  {
    id: "HOTEL_HOTEL_VILLA_BELROSE_GASSIN",
    nom: "Hôtel Villa Belrose",
    adresse: "Boulevard des Crêtes, 83580 Gassin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2352,
      lon: 6.5998,
    },
  },
  {
    id: "HOTEL_LE_MAS_DE_CHASTELAS_GASSIN",
    nom: "Le Mas de Chastelas",
    adresse: "Route de Bourrian, 83580 Gassin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2345,
      lon: 6.591,
    },
  },
  {
    id: "HOTEL_KUBE_HOTEL_SAINT_TROPEZ_GASSIN",
    nom: "Kube Hôtel Saint-Tropez",
    adresse: "Route de l'Epi, 83580 Gassin",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.238,
      lon: 6.5872,
    },
  },
  {
    id: "HOTEL_LE_HAMEAU_DES_PESQUIERS_HYERES",
    nom: "Le Hameau des Pesquiers",
    adresse: "Presqu'île de Giens, 83400 Hyères",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.0291,
      lon: 6.148,
    },
  },
  {
    id: "HOTEL_HOSTELLERIE_DE_L_ABBAYE_DE_LA_CELLE_LA_CELLE",
    nom: "Hostellerie de l'Abbaye de La Celle",
    adresse: "10 place du Général de Gaulle, 83170 La Celle",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.391,
      lon: 5.981,
    },
  },
  {
    id: "HOTEL_HOTEL_CHATEAU_DE_VALMER_LA_CROIX_VALMER",
    nom: "Hôtel Château de Valmer",
    adresse: "Plage de Gigaro, 83420 La Croix-Valmer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.1892,
      lon: 6.5728,
    },
  },
  {
    id: "HOTEL_HOTEL_LILY_OF_THE_VALLEY_LA_CROIX_VALMER",
    nom: "Hôtel Lily of the Valley",
    adresse: "Route de Gigaro, 83420 La Croix-Valmer",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.1912,
      lon: 6.5701,
    },
  },
  {
    id: "HOTEL_HOTEL_DU_CASTELLET_LE_CASTELLET",
    nom: "Hôtel du Castellet",
    adresse: "3001 route des Hauts du Camp, 83330 Le Castellet",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.1991,
      lon: 5.7826,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_CLUB_DE_CAVALIERE_SPA_LE_LAVANDOU",
    nom: "Hôtel Le Club de Cavalière & Spa",
    adresse: "Avenue du Cap Nègre, 83980 Le Lavandou",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.1305,
      lon: 6.378,
    },
  },
  {
    id: "HOTEL_HOTEL_LES_ROCHES_LE_LAVANDOU",
    nom: "Hôtel Les Roches",
    adresse: "1 avenue des Trois Dauphins, 83980 Le Lavandou",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.1298,
      lon: 6.371,
    },
  },
  {
    id: "HOTEL_VILLA_MARIE_SAINT_TROPEZ_RAMATUELLE",
    nom: "Villa Marie Saint-Tropez",
    adresse: "Chemin Val Rian, 83350 Ramatuelle",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2168,
      lon: 6.6301,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_RESERVE_RAMATUELLE_RAMATUELLE",
    nom: "Hôtel La Réserve Ramatuelle",
    adresse: "Route de la Belle Isnarde, 83350 Ramatuelle",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.223,
      lon: 6.626,
    },
  },
  {
    id: "HOTEL_MUSE_HOTEL_SAINT_TROPEZ_RAMATUELLE",
    nom: "Muse Hôtel Saint-Tropez",
    adresse: "135 chemin de Quinsanne, 83350 Ramatuelle",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2102,
      lon: 6.6398,
    },
  },
  {
    id: "HOTEL_HOTEL_SPA_LE_DAYA_ROQUEBRUNE_SUR_ARGENS",
    nom: "Hôtel & Spa Le Daya",
    adresse: "1 rue des Pins, 83520 Roquebrune-sur-Argens",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.442,
      lon: 6.628,
    },
  },
  {
    id: "HOTEL_HOTEL_LES_ROCHES_ROUGES_SAINT_RAPHAEL",
    nom: "Hôtel Les Roches Rouges",
    adresse: "2150 route de la Corniche, 83700 Saint-Raphaël",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.4149,
      lon: 6.8402,
    },
  },
  {
    id: "HOTEL_LA_VILLA_MAURESQUE_SAINT_RAPHAEL",
    nom: "La Villa Mauresque",
    adresse: "1792 route de la Corniche, 83700 Saint-Raphaël",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.4161,
      lon: 6.8385,
    },
  },
  {
    id: "HOTEL_HOTEL_CHATEAU_DE_LA_MESSARDIERE_SAINT_TROPEZ",
    nom: "Hôtel Château de la Messardière",
    adresse: "2 route de Tahiti, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2543,
      lon: 6.6579,
    },
  },
  {
    id: "HOTEL_HOTEL_AREV_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Hôtel Arev Saint-Tropez",
    adresse: "8 chemin de Vendanges, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2668,
      lon: 6.6471,
    },
  },
  {
    id: "HOTEL_HOTEL_BYBLOS_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Hôtel Byblos Saint-Tropez",
    adresse: "20 avenue Paul Signac, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2705,
      lon: 6.6439,
    },
  },
  {
    id: "HOTEL_HOTEL_DE_PARIS_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Hôtel de Paris Saint-Tropez",
    adresse: "Place de la Croix de Fer, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2722,
      lon: 6.6402,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_BASTIDE_DE_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Hôtel La Bastide de Saint-Tropez",
    adresse: "25 route des Carles, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.268,
      lon: 6.6482,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_MANDARINE_SAINT_TROPEZ",
    nom: "Hôtel La Mandarine",
    adresse: "Chemin de la Belle Isnarde, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2655,
      lon: 6.651,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_PONCHE_SAINT_TROPEZ",
    nom: "Hôtel La Ponche",
    adresse: "5 rue des Remparts, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2731,
      lon: 6.6389,
    },
  },
  {
    id: "HOTEL_HOTEL_LA_TARTANE_SAINT_AMOUR_SAINT_TROPEZ",
    nom: "Hôtel La Tartane Saint-Amour",
    adresse: "231 route des Salins, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.271,
      lon: 6.6612,
    },
  },
  {
    id: "HOTEL_CHEVAL_BLANC_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Cheval Blanc Saint-Tropez",
    adresse: "Plage de la Bouillabaisse, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2665,
      lon: 6.6266,
    },
  },
  {
    id: "HOTEL_HOTEL_LE_YACA_SAINT_TROPEZ",
    nom: "Hôtel Le Yaca",
    adresse: "1 boulevard d'Aumale, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2718,
      lon: 6.6396,
    },
  },
  {
    id: "HOTEL_HOTEL_LOU_PINET_SAINT_TROPEZ",
    nom: "Hôtel Lou Pinet",
    adresse: "70 chemin du Pinet, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.275,
      lon: 6.635,
    },
  },
  {
    id: "HOTEL_HOTEL_SEZZ_SAINT_TROPEZ_SAINT_TROPEZ",
    nom: "Hôtel Sezz Saint-Tropez",
    adresse: "151 route des Salins, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2705,
      lon: 6.6598,
    },
  },
  {
    id: "HOTEL_VILLA_COSY_HOTEL_SPA_SAINT_TROPEZ",
    nom: "Villa Cosy Hôtel & Spa",
    adresse: "22 chemin de la Belle Isnarde, 83990 Saint-Tropez",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.2648,
      lon: 6.6515,
    },
  },
  {
    id: "HOTEL_TERRE_BLANCHE_HOTEL_SPA_GOLF_RESORT_TOURRETTES",
    nom: "Terre Blanche Hôtel Spa Golf Resort",
    adresse: "3100 route de Bagnols-en-Forêt, 83440 Tourrettes",
    type: "hotel",
    icon: "ph:buildings",
    coordinates: {
      lat: 43.5905,
      lon: 6.711,
    },
  },
];
